import { ANIMATION_IDENTIFIERS, DrawAnimationMechanicConfig } from '@Animation/types'
import { PlinkoNumber, PlinkoForeground, preLoadAssets, PlinkoNumberSelector } from '.'
import { PLUS_3_CONFIG } from '../add-on-extra-draw/plus-3/config'
import { NoBackground } from '../base/background'
import { MI_MULTIPLIER_PUTTING_CONFIG } from '../add-on-multiplier/michigan-kicker/putting/config'
import { PlinkoTextureLoader } from './texture-loader'

export const PlinkoConfig: DrawAnimationMechanicConfig = {
  appSettings: {
    backgroundBaseColor: '#061127',
    backgroundGlowColor: '#FFCA4E',
    backgroundUrl: '/animations/plinko/background.png',
  },
  numberSelector: PlinkoNumberSelector,
  background: NoBackground,
  foreground: PlinkoForeground,
  kenoNumber: PlinkoNumber,
  multiplierAnimationConfig: MI_MULTIPLIER_PUTTING_CONFIG,
  assetPreloader: preLoadAssets,
  extraDrawAnimationConfig: PLUS_3_CONFIG(ANIMATION_IDENTIFIERS.PLINKO),
  textureLoader: PlinkoTextureLoader,
}
